import { createSlice } from "@reduxjs/toolkit";
import { getMeristemContext } from "src/utils/meristemContext";

const languageSlice = createSlice({
  name: "language",
  initialState: getMeristemContext().language_code || "en",
  reducers: {
    setLanguage(state, action) {
      return action.payload || state;
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export default languageSlice.reducer;
